module.exports = __webpack_public_path__ + "img/splash.0c9acf86.png";